export default __webpack_public_path__ + "static/media/141.a521f467.svg";